const BackgroundConfigAggregator = (node) => {
    const widgetConfig = Object.fromEntries(
        Array.from(node.attributes)
            .filter(({ name }) => name.startsWith('data-w'))
            .map(({ name, value }) => [name.slice(7), value])
    )

    const backgroundAttributesNode = Array.from(node.children).find(
        (child) =>
            child.getAttribute('data-element') === 'background_attributes'
    )

    const backgroundAttributes = backgroundAttributesNode
        ? Object.fromEntries(
              Array.from(
                  backgroundAttributesNode.attributes
              ).map(({ name, value }) => [name, value])
          )
        : {}

    const dataBackgroundImages = node.getAttribute('data-background-images')
    if (dataBackgroundImages) {
        try {
            const images = JSON.parse(dataBackgroundImages.replace(/\\"/g, '"'))
            backgroundAttributes.desktop_image = images.desktop_image || null
            backgroundAttributes.mobile_image = images.mobile_image || null
        } catch (error) {
            console.error('Failed to parse data-background-images:', error)
        }
    }
    return {
        html: node.innerHTML,
        widgetConfiguration: widgetConfig,
        backgroundAttributes
    }
}

export default BackgroundConfigAggregator
